import 'uni-pages';import 'uni-h5';import App from './App.vue';
// import i18n from './common/i18n'; // 引入 i18n



import Vue from 'vue';

Vue.config.productionTip = false;
App.mpType = 'app';

// 挂载 i18n
var app = new Vue({
	// i18n, // 在 Vue 2 中注册 i18n
	...App
});

app.$mount();


























